"use strict";
var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:PageSliderView"); //https://github.com/visionmedia/debug

/**
 * RetronewsPageSliderView: Display a page thumbnail slider like ibooks
 */
module.exports = Backbone.View.extend({

    model: null, // DocumentModel
    knobMinWidth: 40,
    knobMaxWidth: 100,
    templateKnob: null,
    templateThumb: null,
    fixedWidth: 0,
    authorizedPages: null,
    embed: false, // en mode embed on désactive touch-action:none (bug de scroll à partir d'ios 14)

    events: {
        "pointerdown .knob": "onDragStart",
        "click": "onClick"
    },

    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        if (T.fixedWidth) {
            T.knobMinWidth = T.fixedWidth;
            T.knobMaxWidth = T.fixedWidth;
        }

        T._knobWidth = 0;
        T._step = 0;
        T._pointers = {};
        T._dragStartPoint = {
            x: 0,
            y: 0
        };
        T._dragStartLeft = 0;


        if (T.templateKnob) {
            T.templateKnob = _.template(T.templateKnob); // compile template
        }

        if (T.templateThumb) {
            T.templateThumb = _.template(T.templateThumb); // compile template
        }

        T.listenTo(T.model, "sync", T.render);
        T.listenTo(T.model, "change:page", T.update);
    },

    render: function () {
        var T = this;

        if (T.model.fetched) {
            var context = T.model.toJSON();
            if (T.templateKnob) {
                T.$el.html("");
                T.$knob = $(T.templateKnob(context));
                T.$el.append(T.$knob);

                T.$thumb = $(T.templateThumb(context));
                T.$el.append(T.$thumb);
                T.$thumb.hide();

                if (!T.embed) {
                    T.$el.css("touch-action", "none");
                }
            }
            T.resize();
        }
        return T;
    },

    /**
     * adjust slider size from nb pages and container width
     */
    resize: function () {
        var T = this;

        if (!T.model.fetched) return;

        T._elWidth = T.$el.width();
        T._elHeight = T.$el.height();

        T._knobWidth = T._elWidth / (T.model.get("nbPages") - 1);

        if (T._knobWidth < T.knobMinWidth) {
            T._knobWidth = T.knobMinWidth;
        } else if (T._knobWidth > T.knobMaxWidth) {
            T._knobWidth = T.knobMaxWidth;
        }

        T._step = (T._elWidth - T._knobWidth) / (T.model.get("nbPages") - 1);


        T.$knob.css({
            width: T._knobWidth
        });

        T.update();

    },

    update: function () {
        var T = this;
        if (!T.model.fetched) return;
        var page = T.model.get("page") || 1;
        var knob_left = T._step * (page - 1);

        // console.log("page "+ page+" el width: "+T._elWidth +" left:"+ knob_left +" knob:"+ T._knobWidth );

        // move slider to current page
        T.$knob.css({
            left: knob_left
        });
    },

    onDragStart: function (e) {
        var T = this;

        T._pointers[e.originalEvent.pointerId] = {
            pageX: e.pageX,
            pageY: e.pageY
        };

        var keys = _.keys(T._pointers);

        if (keys.length == 1) {
            T._dragStartPoint.x = e.pageX;
            T._dragStartPoint.y = e.pageY;
            $(window).on("pointermove.pv5-slider", function (e) {
                T.onDragMove(e);
            });
            $(window).on("pointerup.pv5-slider", function (e) {
                T.onDragEnd(e);
            });
            $(window).on("pointercancel.pv5-slider", function (e) {
                T.onDragEnd(e);
            });
            T._dragStartLeft = T.knobPosition();
            //T._gotoPage=T.pageFromKnobPosition(T.knobPosition());
            var page = T.pageFromKnobPosition(T.knobPosition());
            T.updateThumb(page);
            T.$thumb.show();
        } else {
            T._abortDrag = true;
        }

        //console.log(T._dragStartPoint.x+" "+T._dragStartPoint.x+" "+T._dragStartLeft);*/
    },

    onDragMove: function (e) {
        var T = this;

        if (T._abortDrag) return;

        //console.log("drag move doc "+e.type);
        T._pointers[e.originalEvent.pointerId] = {
            pageX: e.pageX,
            pageY: e.pageY
        };

        var keys = _.keys(T._pointers);
        if (keys.length == 1) {
            var knob_left = T._dragStartLeft - (T._dragStartPoint.x - e.pageX);
            T.knobPosition(knob_left);
            T.$el.addClass("grabbing");
            var page = T.pageFromKnobPosition(T.knobPosition());
            if (T._previousPageThumb != page) {
                T.updateThumb(page);
                T._previousPageThumb = page;
            }
        }

    },

    onDragEnd: function (e) {
        var T = this;

        delete T._pointers[e.originalEvent.pointerId];

        var keys = _.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if (!keys.length) {
            $(window).off(".pv5-slider");
            T._abortDrag = false;
            var page = T.pageFromKnobPosition(T.knobPosition());
            debug("gotopage " + page);
            T.trigger("drag:end");
            T.model.set({
                "page": page
            });
            T.$el.removeClass("grabbing");
            T.$thumb.hide();
        }
    },

    onClick: function (e) {
        var T = this;
        if (e.target == T.el) {
            var x = e.pageX - T.$el.offset().left - (T._knobWidth / 2);
            if (x < 0) {
                x = 0;
            }
            var page = T.pageFromKnobPosition(x);
            debug("click slider position : " + x + " page : " + page);
            T.trigger("click");
            T.model.set({
                "page": page
            });
        }
    },

    updateThumb: function (page) {
        var T = this, str_page;

        if (T.model.get("reversed")) {
            str_page = String(T.model.get("nbPages") - page + 1);
        }
        else {
            str_page = String(page);
        }
        T.$(".page").html(str_page);
        if (T.model.get("isDouble")) {
            if (page > 1) {
                page = (page % 2) ? page - 1 : page;
            }
            T.$(".cover").toggleClass("double-page", !(page == 1 || page == T.model.get("nbPages")));
        }

        if (T.bgTimer) {
            clearTimeout(T.bgTimer);
            T.bgTimer = 0;
        }
        if (page != T.bgPage) {
            T.$(".cover").css({
                backgroundImage: "none"
            });
        }

        T.bgPage = page;

        //  on attend un peu avant d'affecter l'image ça évite de charger toutes les images lors d'un long drag
        T.bgTimer = setTimeout(function () {
            T.$thumb.toggleClass("page-not-authorized", !T.isPageAuthorized(page));
            T.$(".cover").css({
                backgroundImage: "url(" + T.model.thumbnailUrl(page) + ")"
            });
        }, 100);

    },

    pageFromKnobPosition: function (p) {
        var T = this,
            page;
        page = Math.round(p / T._step);
        return page + 1;
    },

    isPageAuthorized: function (page) {
        var T = this;
        if (_.isArray(T.authorizedPages)) {
            return T.authorizedPages.indexOf(page) != -1;
        }
        else {
            return true;
        }
    },


    knobPosition: function (p) {
        var T = this;
        if (p) {
            //console.log(p);
            // clamp poision
            if (p < 0) {
                p = 0;
            } else if (p > T._elWidth - T._knobWidth) {
                p = T._elWidth - T._knobWidth;
            }

            var knob_left = p;

            T.$knob.css({
                left: knob_left
            });
        } else {
            return parseInt(T.$knob.css("left"));
        }

    },

    close: function () {
        var T = this;
        T.$knob = null;
        T.stopListening();
        T.undelegateEvents();
    }

});